import Form from '../../form';
import addServices from '../../addServices';
import Vue from "vue";

let app = new Vue({
    el: '#app-vpbooking',

    mounted: function () {
        let vm = this;
        $("#app-vpbooking").on('focusout', function (event) {
            let elemName = event.target.getAttribute('name');
            let elemType = event.target.getAttribute('type');
            if (event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                vm.form.errors.clear(elemName);
            }
            if (elemType == 'text' || event.target.tagName.toLowerCase() == 'textarea') {
                console.log(elemName);
                if (elemName != 'email' && (typeof app.form[elemName] === 'string')) {
                    app.form[elemName] = app.form[elemName].toUpperCase();
                }
            }
            if (event.target.classList.contains('needcheck')) {
                var i = app.needcheck.indexOf(elemName);
                if (i > -1) {
                    app.needcheck.splice(i, 1);
                }
                console.log(app.needcheck);

            }
        });
    },

    data: {
        form: new Form({
            id: '',
            uid: '',
            payservice: 'no',
            airport: '',
            name: '',
            RM: '',
            email: '',
            phone: '',
            amexbookingcode:'',
            tmexception: false,
            pspnumber:'',
            pspinfo:'',
            flightdata: '',
            returndata: '',
            indate: '',
            intime: '',
            handofflocation: '',
            outdate: '',
            outtime: '',
            parkingdays: '',
            pkadd: '',
            returnlocation: '',
            registration: '',
            details: '',
            remark: '',
            remarkC: '',
            remarks: '',
            baggage: '',
            additionalServices: '',
            state: ''

        }),
        saved: false,
        blocked: false,
        alertAccepted: false,
        submitting: false,
        flightDataChecked: false,
        editable: true,
        inPast: false,
        showStorno: false,
        inStornoTime: true,
        inServiceTime: true,
        handovers: [],
        needcheck: [],
        disabled: [],
        isAdmin: false,
        isTls: false,
        RMs:[],
        pspinfooptions: window.translations.psp_info_options[window.locale]
    },

    components: {},
    computed: {
        flightdata() {
            return this.form.flightdata;
        },
        returndata() {
            return this.form.transitdata;
        },
        indate() {
            return this.form.indate;
        },
        outdate() {
            return this.form.outdate;
        },
        isEdit() {
            return (this.form.id !== '');
        },
        amexbookingcode() {
            return this.form.amexbookingcode;
        },
        submitEnabled() {
            return this.flightDataChecked && !this.blocked;
        }

    },
    watch: {
        flightdata() {
            if(!this.isTls) {
                return;
            }
            if (this.isEdit) {
                if (this.form.flightdata != this.form.originalData.flightdata) {
                    this.resetDates();
                    this.alertAccepted = false;
                }
            } else {
                this.resetDates();
                this.alertAccepted = false;
            }
        },
        returndata() {
            if(!this.isTls) {
                return;
            }
            if (this.isEdit) {
                if (this.form.returndata != this.form.originalData.returndata) {
                    this.resetDates();
                    this.alertAccepted = false;
                }
            } else {
                this.resetDates();
                this.alertAccepted = false;
            }
        },
        indate() {
            if(this.isTls) {
                return;
            }
            if (this.isEdit) {
                if (this.form.indate != this.form.originalData.indate) {
                    this.alertAccepted = false;
                }
            } else {
                this.alertAccepted = false;
            }
        },
        outdate() {
            if(this.isTls) {
                return;
            }
            if (this.isEdit) {
                if (this.form.outdate != this.form.originalData.outdate) {
                    this.alertAccepted = false;
                }
            } else {
                this.alertAccepted = false;
            }
        },
        amexbookingcode() {
            if(this.form.amexbookingcode!=null && this.form.amexbookingcode!='') {
                this.form.tmexception = false;
                this.form.pspinfo = '';
                this.form.pspnumber = '';
            }
        },
        flightDataChecked() {
            if ((this.isEdit)) {
                //this.needcheck.push('flightdata');
                //this.needcheck.push('returndata');
            }
        },
        submitting() {
            if (this.submitting) {
                $("#overlay").show();
            } else {
                $("#overlay").hide();
            }
        }

    },
    methods: {
        init(appdata) {
            this.form.init(appdata.formdata);
            this.editable = appdata.editable == '1' ? true : false;
            this.showStorno = appdata.showStorno == '1' ? true : false;
            this.inPast = appdata.inPast == '1' ? true : false;
            this.handovers = appdata.handovers;
            this.inServiceTime = appdata.inServiceTime == '1' ? true : false;
            this.flightDataChecked = appdata.flightDataChecked == '1' ? true : false;
            this.disabled = appdata.disabled;
            this.isAdmin = appdata.isAdmin;
            this.isTls = appdata.isTls;
            if(this.isTls) {
                this.RMs = appdata.RMs;
            }
        },
        resetDates() {
            this.form.indate = '';
            this.form.outdate = '';
            this.form.intime = '';
            this.form.outtime = '';
            this.flightDataChecked = false;
        },
        onSubmit(event) {
            console.log('onsubmit');
            if (this.needcheck.length != 0) {
                swal({
                    type: 'warning',
                    text: 'Bitte prüfen Sie die markierten Felder.',
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return false;
            }
            this.form.errors.clear();

            if (this.flightDataChecked) {
                this.submitting = true;
                this.submit();
            } else {
                this.calcDates(event, 'submit');
            }
        },
        needCheck(name) {
            if (_.indexOf(this.needcheck, name) !== -1) {
                return 'needcheck';
            } else {
                return '';
            }
        },
        submit() {
            console.log('submit');
            this.form.post(document.getElementById('vpbookingform').getAttribute('action'))
                .then(response => {
                    if (response.hasOwnProperty('message')) {
                        swal({
                            type: 'error',
                            title: window.translations.save_error_title[window.locale],
                            text: window.translations.save_error_text[window.locale],
                            confirmButtonText: window.translations.proceed[window.locale],
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                        this.submitting = false;
                        return false;
                    }
                    this.saved = true;
                    console.log(response.bookingId);
                    swal({
                        type: 'success',
                        title: window.translations.save_success_title[window.locale],
                        text: window.translations.save_success_text[window.locale],
                        confirmButtonText: window.translations.proceed[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        location.href = response.nextUrl;
                    })
                })
                .catch(
                    error => {
                        console.log(error);
                        this.saved = false;
                        this.submitting = false;
                    }
                )
        },
        storno(url) {
            console.log('storno');
            swal({
                type: 'question',
                title: window.translations.storno_title[window.locale],
                text: window.translations.storno_text[window.locale],
                confirmButtonText: window.translations.storno[window.locale],
                showCancelButton: true,
                cancelButtonText: window.translations.cancel[window.locale],
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.doStorno(url);
                } else {
                    return;
                }
            })
        },
        doStorno(url) {
            this.submitting = true;
            this.form.post(url)
                .then(response => {
                    this.saved = true;
                    swal({
                        type: 'success',
                        title: window.translations.storno_success_title[window.locale],
                        text: window.translations.storno_success_text[window.locale],
                        confirmButtonText: window.translations.storno[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        location.href = response.nextUrl;
                    })
                })
                .catch(
                    error => {
                        console.log(error);
                        this.submitting = false;
                    }
                )
        },
        gotoSend(url) {
            location.href = url;
        },
        showRemarks(event) {
            swal({
                title: window.translations.remark[window.locale],
                html: this.form.remarks
            })
        },
        showAddServices(event) {
            console.log(event);
            let addS = new addServices();
            addS.showModal(this.form.airport, 'vp', this.form.additionalServices, app);
        },
        calcDates(event, successMethod) {
            if (!this.editable) {
                return;
            }
            if (event.target.getAttribute('readonly')) {
                return;
            }
            console.log('calcdates');
            if (this.form.flightdata !== '') {
                this.form.flightdata = this.form.sanitizeValue(this.form.flightdata);
            }
            if (this.form.returndata !== '') {
                this.form.returndata = this.form.sanitizeValue(this.form.returndata);
            }
            //todo waitmessage
            this.form.errors.clear('flightdata');
            this.form.errors.clear('returndata');
            this.form.errors.clear('indate');
            this.form.errors.clear('outdate');
            this.form.errors.clear('intime');
            this.form.errors.clear('outtime');
            let elemName = event.target.getAttribute("name");
            axios.post('/vpservice/checkAndCalculateDates', {
                inputelem: elemName,
                airport: this.form.airport,
                flightdata: this.form.flightdata,
                returndata: this.form.returndata,
                intime: this.form.intime,
                outtime: this.form.outtime,
                indate: this.form.indate,
                outdate: this.form.outdate,
                disabled: this.disabled,
                parking: this.form.parking_category
            })
                .then(response => {
                    console.log('then');
                    console.log(response.data);
                    if (response.data) {
                        console.log('data');
                        this.flightDataChecked = true;
                        if (response.data.indate !== this.form.indate) {
                            this.$set(this.form, 'indate', response.data.indate);
                            this.needcheck.push('indate');
                        }
                        if (response.data.intime !== this.form.intime) {
                            this.$set(this.form, 'intime', response.data.intime);
                            this.needcheck.push('intime');
                        }
                        if (response.data.outdate !== this.form.outdate) {
                            this.$set(this.form, 'outdate', response.data.outdate);
                            this.needcheck.push('outdate');
                        }
                        if (response.data.outtime !== this.form.outtime) {
                            this.$set(this.form, 'outtime', response.data.outtime);
                            this.needcheck.push('outtime');
                        }
                        if (response.data.intime == '') {
                            this.$set(this.form, 'intime', '');
                            this.needcheck.push('intime');
                        }
                        if (response.data.outtime == '') {
                            this.$set(this.form, 'outtime', '');
                            this.needcheck.push('outtime');
                        }


                        this.$set(this.form, 'parkingdays', response.data.parkingdays);
                        this.$set(this.form, 'pkadd', response.data.pkadd);
                        if (response.data.handoverLoc !== '') {
                            if (this.form.handofflocation == '') {
                                this.$set(this.form, 'handofflocation', response.data.handoverLoc);
                                this.needcheck.push('handofflocation');


                            }


                        }
                        if (response.data.returnLoc !== '') {
                            if (this.form.returnlocation == '') {
                                this.$set(this.form, 'returnlocation', response.data.returnLoc);

                                this.needcheck.push('returnlocation');

                            }

                        }
                        if (response.data.alertFlight == '' && response.data.alertReturn == '') {
                            this.alertAccepted = true;
                            this.blocked = false;
                        } else if(!this.alertAccepted) {
                            let msg = "";
                            if (response.data.alertFlight !== '') {
                                if(response.data.alertFlight.indexOf('blocking') !== -1) {
                                    this.blocked = true;
                                } else {
                                    this.blocked = false;
                                }
                                msg = "<h5>Übergabe:</h5>"+response.data.alertFlight;
                            }
                            if (response.data.alertReturn !== '') {
                                if(response.data.alertReturn.indexOf('blocking') !== -1) {
                                    this.blocked = true;
                                } else {
                                    this.blocked = this.blocked && false;
                                }
                                msg += "<h5>Rückgabe:</h5>"+response.data.alertReturn;
                            }
                            if(msg !== "") {
                                swal({
                                    type: 'warning',
                                    title: 'Wichtiger Hinweis',
                                    html: msg
                                }).then((result) => {
                                    this.alertAccepted = true;
                                })
                            }


                        }


                        this.inServiceTime = response.data.inServiceTime;
                        this.needcheck = _.uniq(this.needcheck);
                        console.log(successMethod);
                        if (!(typeof successMethod == 'undefined') && !this.blocked) {
                            console.log(successMethod);
                            this[successMethod]();
                        }
                    }
                })
                .catch(error => {
                    console.log('error');

                    this.flightDataChecked = false;
                    this.form.onFail(error.response.data);


                });

        },
        checkDates1(event) {
            this.form.errors.clear('indate');
            this.form.errors.clear('outdate');
            axios.post('/vpservice/checkDates', {
                airport: this.form.airport,
                intime: this.form.intime,
                outtime: this.form.outtime,
                indate: this.form.indate,
                outdate: this.form.outdate
            })
                .then(response => {
                    console.log(response.data);
                    if (response.data) {
                        this.flightDataChecked = true;
                        this.$set(this.form, 'parkingdays', response.data.parkingdays);
                        this.$set(this.form, 'pkadd', response.data.pkadd);
                        this.inServiceTime = response.data.inServiceTime;

                    }
                })
                .catch(error => {
                    console.log(error);
                    this.flightDataChecked = false;
                    this.form.onFail(error.response.data);
                });

        },
        checkReadOnly(elemName) {
            if(this.isAdmin) {
                return false;
            }
            if (this.disabled.indexOf(elemName) > -1 || this.editable === false) {
                return true;
            } else {
                return false;
            }
        }


    }
});

export default app;